import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE, PRICE_FULL, PRICE_SHORT, Section } from './Shared';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 56,
    s: 9
  });
  const spotsTaken = 78;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-141" data-mp="2kbtvu1zyzdhc">
      <div className="min-w-[58px] rounded-xl bg-brand-purple px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight shadow-sm ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-142" data-mp="12r80szc4kviw">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-143" data-mp="1cilwsx4vbd7a">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-144" data-mp="1mep9gwxciu8h">
      <div className="glass-panel rounded-3xl border-2 border-brand-gold/40 p-6 md:p-8" data-id="element-145" data-mp="1mhl68hxgjcvc">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-146" data-mp="1hg4at1xqsim5">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-147" data-mp="1vf3tzu2hk5ax" />
          <h3 className="font-serif text-base font-bold text-brand-purpleDark md:text-xl" data-id="element-148" data-mp="1qhbuoezihgwp">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-149" data-mp="148cg29bpfw0">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-150" data-mp="3s9zzutvpuef4" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-151" data-mp="1w5k7dm6jp4ho">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-152" data-mp="1w7n8p2d5ek1p" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-153" data-mp="215galj7f4rw6">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-154" data-mp="262ylvg8wrj7c" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/40 px-4 py-3" data-id="element-155" data-mp="265ulra4bghyf">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-156" data-mp="2f4y60hf7z3ei" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-157" data-mp="2k2zph3gk54qi">
            Después sube. <span className="text-brand-purple" data-id="element-158" data-mp="2ou7u7m6y01xc">No vuelve.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-purple/20 bg-white p-4 md:p-5" data-id="element-159" data-mp="2tsszi011xbsn">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-160" data-mp="2xunz903c3h4b">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-161" data-mp="32tqtdphs02xi">
              <span className="relative flex h-2.5 w-2.5" data-id="element-162" data-mp="r65hzr1v1c2j">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-goldBright opacity-75" data-id="element-163" data-mp="r7oxvgjltl3s" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-goldBright" data-id="element-164" data-mp="i5pg2m0rmczs" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-purple" data-id="element-165" data-mp="d8pcqivavocd">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-purple/10" data-id="element-166" data-mp="15vjsx3l341k1">
            <div className="h-full rounded-full bg-brand-purple" style={{
            width: `${spotsTaken}%`
          }} data-id="element-167" data-mp="114l6rndf098v" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-168" data-mp="w609nwtgm5on">
            <strong className="text-brand-purple" data-id="element-169" data-mp="1tkvxfq5gvlg0">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="pricing" glow className="my-12 rounded-3xl border border-brand-gold/45 bg-brand-surfaceLight" data-id="element-170" data-mp="18ewn2tiqb67w">
      <div className="relative mb-10 text-center" data-id="element-171" data-mp="1de9abfdiifb0">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-purple px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-172" data-mp="1df12shbtbwx2">
          ✨ Oferta de lanzamiento
        </span>
        <h2 className="font-display text-3xl font-bold text-brand-purpleDark md:text-4xl" data-id="element-173" data-mp="1s2du6moawwvd">
          TU <span className="headline-shine" data-id="element-174" data-mp="1w4qyd6negmq1">MEGA PACK MAESTRO DE GEMOTERAPIA</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-175" data-mp="1idcg521bgpk1">⏰ El precio de lanzamiento cierra pronto.</p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-176" data-mp="1navu00u3r0bg">
        <div className="relative rounded-3xl" data-id="element-177" data-mp="1n9ksy8s1k6o1">
          <span className="glow-frame" aria-hidden="true" data-id="element-178" data-mp="2b0gmbac5b9xe" />
          <div className="relative z-10 rounded-3xl bg-white p-5 shadow-lg md:p-7" data-id="element-179" data-mp="2fs88l8o9qthq">
            <div className="mb-2 flex items-center gap-1.5 text-brand-goldDark" data-id="element-180" data-mp="2fu1gerambjrb">
              <TrophyIcon className="h-4 w-4 fill-current" data-id="element-181" data-mp="2p575t9py35cw" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-182" data-mp="2l4dl0p7su6o8" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-183" data-mp="2ywtsq3bnasvh">El sistema más completo</span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-5" data-id="element-184" data-mp="2txgxovamefht">
              <div className="max-w-md" data-id="element-185" data-mp="267w8hunvim03">
                <h3 className="font-serif text-lg font-bold text-brand-purpleDark md:text-xl" data-id="element-186" data-mp="268o77ecrozul">
                  🏆 MEGA PACK MAESTRO DE GEMOTERAPIA™
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-187" data-mp="2g6lthwb2gmkk">4 Tomos + 5 Bonus · Más de 160 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-purple" data-id="element-188" data-mp="2b6zepiflay9n">
                  El sistema integral de protocolos, cristales, chakras, protección energética, seguimiento del paciente
                  y posicionamiento profesional para la terapeuta en Gemoterapia Holística.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-189" data-mp="3up6j581vxx1o">
                <p className="text-sm text-brand-muted line-through" data-id="element-190" data-mp="2ijgshfv95yg">{PRICE_FULL}</p>
                <p className="font-serif text-2xl font-bold text-brand-purple" data-id="element-191" data-mp="7hw413angf1k">{PRICE}</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} animate={{
        scale: [1, 1.015, 1]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-purple px-6 py-5 text-center text-base font-bold text-brand-goldLight ring-1 ring-brand-gold/50 shadow-[0_12px_28px_rgba(42,18,89,.26)] md:text-xl" data-id="element-192" data-mp="cgpgqti4420o">
          <span className="relative z-10" data-id="element-193" data-mp="2s6sjj0eq4dm5">→ QUIERO MI MEGA PACK {PRICE_SHORT}</span>
        </motion.a>
        <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-194" data-mp="2x5d822km58ur">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳 Mercado Pago
        </p>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-195" data-mp="2fozn13fw0x35">
      <LaunchUrgency data-id="element-196" data-mp="2ar6guael432v" />
      <Pricing data-id="element-197" data-mp="2arpnguysb51l" />
    </div>;
}